import React, {useState, useEffect, useRef, useContext} from 'react';
import ChantierInfoCheckinView from './ChantierInfoCheckinView';
import swal from 'sweetalert';
import Spinner from '../../Spinner/Spinner';
import {getCheckinChantier, getUsers} from '../../../services/MadricService';
import {useParams} from 'react-router-dom';
import moment from 'moment/moment';
import {MadricContext} from '../../../Context/MadricContext';

/**
 *  L'accueil
 * @return {JSX}
 */
function ChantierInfoCheckin() {
  const [isLoading, setIsLoading] = useState(false);

  const [filteredCheckin, setFilteredCheckin] = useState([]);

  const {projectInfoObtained, projectInfo, setProjectInfo, listeEmploye, setListeEmploye} = useContext(MadricContext);

  const {id} = useParams();
  const filterForm = useRef({inputRef: {label: 'Filtrer par nom'},
    dateRef: '',
    extra1: false,
    extra2: false,
    extra3: false});

  useEffect(() => {
    if (!projectInfoObtained.current.includes('checkin')) {
      projectInfoObtained.current = [...projectInfoObtained.current, 'checkin'];
      fetchCheckin();
    } else {
      setFilteredCheckin(projectInfo.filter((item) => item.type === 'checkin'));
    }

    if (listeEmploye.length === 0) {
      fetchEmploye();
    }
  }, []);

  /**
   * Permet d'allez chercher la liste des chantiers
   */
  async function fetchCheckin() {
    setIsLoading(true);
    const checkins = await getCheckinChantier(id);

    setProjectInfo((prev) => [...prev, ...checkins]);
    setFilteredCheckin(checkins);
    setIsLoading(false);
  }

  /**
   * Permet d'allez chercher la liste d'employe
   */
  async function fetchEmploye() {
    const name = await getUsers();

    setListeEmploye(name);
  }

  /**
   * Supprime le filtre de la date
   */
  function removeDate() {
    filterForm.current = {
      ...filterForm.current,
      dateRef: '',
      inputRef: {label: 'Filtrer par nom'},
    };
    filterData();
  }

  /**
   * Permet de filtrer par le nom
   * @param {*} event event
   */
  function handleChange(event) {
    filterForm.current = {
      ...filterForm.current,
      inputRef: event,
    };
    filterData();
  }

  /**
       * filtre du extra 1
       * @param {*} event event
       */
  function handleCheckboxChange(event) {
    filterForm.current = {
      ...filterForm.current,
      [event.target.name]: event.target.checked,
    };
    filterData();
  }

  /**
       * filtre de la date
       * @param {*} event event
       */
  function handleDateChange(event) {
    filterForm.current = {
      ...filterForm.current,
      dateRef: event,
    };
    filterData();
  }


  const filterExtra = (item1, item2, item3) => {
    const {extra1, extra2, extra3} = filterForm.current;

    const areAllExtrasFalse = !extra1 && !extra2 && !extra3;
    const isItem1Matching = item1 === extra1 && item1;
    const isItem2Matching = item2 === extra2 && item2;
    const isItem3Matching = item3 === extra3 && item3;

    return areAllExtrasFalse || isItem1Matching || isItem2Matching || isItem3Matching;
  };

  const filterData = () => {
    const dateRef = filterForm.current.dateRef;
    const filteredArrays = projectInfo.filter((item) => item.type === 'checkin').filter((item) => {
      const date1 = moment.tz(item.date, 'America/Montreal');
      const date2 = moment.tz(dateRef, 'America/Montreal');

      return ((item.user_name.toLowerCase() === filterForm.current.inputRef.label.toLowerCase() || filterForm.current.inputRef.label === 'Filtrer par nom') &&
        (date1.isSame(date2) || dateRef === '') &&
        filterExtra(item.extra1, item.extra2, item.extra3));
    });

    setFilteredCheckin(filteredArrays);
  };


  /**
   * Permet de supprimer un chantier
   * @param {*} id id du chantier a supprimer
   */
  async function supprimer(id) {
    swal({
      title: '!! Êtes-vous sûre de vouloir supprimer cette tâche !!',
      text: 'Une fois supprimé vous perderez cette tâche',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            swal('Supprimé!', {
              icon: 'success',
            });

            // setToDoList((prevItems) => prevItems.filter((item) => item.id !== id));
            setIsLoading(true);
            // await deleteToDoList(id);
            setIsLoading(false);
          } else {
            swal('Annulé!');
          }
        });
  }

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <ChantierInfoCheckinView
        filteredCheckin={filteredCheckin}
        handleCheckboxChange={handleCheckboxChange}
        removeDate={removeDate}
        handleDateChange={handleDateChange}
        handleChange={handleChange}
        filterForm={filterForm}
        inputRef={filterForm.current.inputRef}
        dateRef={filterForm.current.dateRef}
        supprimer={supprimer} />
    </React.Fragment>
  );
}

export default ChantierInfoCheckin;
